import { store } from '@atredux/store'
import { clearInterrupt, IInterruptData, setInterrupt } from '@atredux/slices/interruptSlice'
import { getInterruptData } from '@atredux/selectors/interruptSelector'

export async function setInterruptListener (event: any) {
    console.log('ATBase: Received request to set interrupt modal.')

    const message = event.data

    if (message && message.data && message.data.message && typeof message.data.message === 'string') {
        const interruptData = {
            ...message.data,
            target: event,
        }
        store.dispatch(setInterrupt(interruptData))
        return Promise.resolve({})
    } else {
        return Promise.reject(`Invalid request parameters, the 'message' field is mandatory`)
    }
}

export async function clearInterruptListener () {
    console.log('ATBase: Received request to clear interrupt modal.')

    store.dispatch(clearInterrupt())

    return Promise.resolve({})
}

export async function getInterruptDataListener () {
    console.log('ATBase: Received request to fetch interrupt data.')

    const interruptData: IInterruptData = getInterruptData(store.getState())

    return Promise.resolve({
        ...interruptData,
        target: undefined,
    })
}
